
import Vue from 'vue';

import * as PatternStore from '@/store/search/form/patterns';
import * as UIStore from '@/store/search/ui';
import { Option } from '@/components/SelectPicker.vue';

export default Vue.extend({
	props: {
		block: {default: false, type: Boolean},
		lg: {default: false, type: Boolean},
	},
	computed: {
		alignByOptions(): Option[] {
			return UIStore.getState().search.shared.alignBy.elements?.map(e => ({
				...e,
				label: this.$tAlignByDisplayName(e),
			}));
		},
		alignBy: {
			get(): string { return PatternStore.get.shared().alignBy || UIStore.getState().search.shared.alignBy.defaultValue; },
			set(value: string) {
				PatternStore.actions.shared.alignBy(value === '' ? null : value);
			},
		}
	},
});
